import { useState, useEffect } from "react";
import { useCourseOptions, useModuleByIdOptions } from "../../hooks/dropdownOptions";
import { useAllModules } from "../../hooks/dropdownOptions";

export const useFormConfig = (initialModuleId = null, isEditMode = false) => {
  const courseOptions = useCourseOptions();
  const [selectedCourseId, setSelectedCourseId] = useState(null);
  const allModules = useAllModules();  
  const moduleOptionsByCourse = useModuleByIdOptions(selectedCourseId);
  const moduleOptions = isEditMode ? allModules : moduleOptionsByCourse;

  useEffect(() => {
  }, [selectedCourseId, moduleOptions]);
  const fieldConfig = [
    {
      key: "title",
      label: "Topic Title",
      type: "text",
      placeholder: "Enter Topic Title",
      required: true,
      alphaOnly: true,
    },
    ...(!isEditMode ? [
      {
        key: "courseId",
        label: "Course",
        type: "dropdown",
        options: courseOptions,
        placeholder: "Select a course",
        required: true,
        onChange: (e) => {
          console.log("Course changed:", e.value);
          setSelectedCourseId(e.value);
        },
      },
    ] : []),
    {
      key: "moduleId",
      label: "Module",
      type: "dropdown",
      options: moduleOptions,
      placeholder: "Select a Module",
      required: true,
      onChange: (e) => console.log("Module changed:", e.value),
    },
    {
      key: "remarks",
      label: "Description",
      type: "text",
      placeholder: "Enter Description",
      required: true,
      alphaOnly: true,
    },
  ];

  return {
    topicForm: {
      formTitle: "Topic",
      initialFormData: {
        title: "",
        courseId: null,
        moduleId: initialModuleId || "",
        isEnable: true,
      },
      fieldConfig: fieldConfig,
    },
  };
};